import { Currency } from '../service_price/currency';
import TaxRate from '../tax_rate';
import { TaxInclusive } from '../tax_rate/tax_inclusive';

interface Props {
  serviceId: number;
  name: string;
  unitAmount: number;
  taxAmount: number;
  taxInclusive: TaxInclusive | null;
  isShowPrice: boolean;
}

export default class EventPaymentLineItem {
  serviceId: number;
  name: string;
  unitAmount: number;
  taxAmount: number;
  taxInclusive: TaxInclusive | null;
  isShowPrice: boolean;

  constructor(props: Props) {
    this.serviceId = props.serviceId;
    this.name = props.name;
    this.unitAmount = props.unitAmount;
    this.taxAmount = props.taxAmount;
    this.taxInclusive = props.taxInclusive;
    this.isShowPrice = props.isShowPrice;
  }

  static calcLineItemTaxIncludedAmount(item: EventPaymentLineItem) {
    if (item.taxInclusive === TaxInclusive.Exclusive) {
      return item.unitAmount + item.taxAmount;
    } else {
      return item.unitAmount;
    }
  }

  static calcLineItemTaxAmount(
    unitAmount: number,
    taxRate: TaxRate | null,
    currency: Currency,
  ) {
    if (unitAmount === 0 || taxRate === null) {
      return 0;
    }

    const percentage = taxRate.percentage / 100;
    let taxAmount = 0;
    if (taxRate.taxInclusive === TaxInclusive.Exclusive) {
      taxAmount = unitAmount * percentage;
    } else {
      taxAmount = (unitAmount / (1 + percentage)) * percentage;
    }
    if (currency === Currency.JPY) {
      return Math.floor(taxAmount);
    } else if (currency === Currency.USD) {
      return Math.floor(taxAmount * 100) / 100;
    } else {
      return Math.floor(taxAmount);
    }
  }
}
